import "./Training.module.css";
import Navigation from "@/reusable_sections/Header";
import FinancialMasteryPath from "./sections/FinancialMasteryPath";
import RenovationFaq from "./sections/RenovationFaq";
import FirmOverview from "./sections/FirmOverview";
import Footer from "@/reusable_sections/Footer";
export default function TrainingPage() {
  return <div>
      <Navigation />
      <FinancialMasteryPath />
      <FirmOverview />
      <RenovationFaq />
      <Footer />
    </div>;
}